export default "__VITE_ASSET__CroPdAdh__"